/* ==========================================================================
   TechNest — sticky-atc.js
   Shows a compact add-to-cart bar once the real buy button has scrolled out of
   view, and hides again when it returns. The bar's button submits the actual
   product form rather than duplicating its logic, so variant selection,
   quantity and validation all still apply.
   ========================================================================== */
(function () {
  'use strict';

  const TN = window.TechNest || {};
  const utils = TN.utils;
  if (!utils) return;

  class TnStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = document.getElementById('ProductForm-' + this.sectionId);
      this.anchor = this.form ? this.form.querySelector('[data-tn-add-button]') : null;
      if (!this.form || !this.anchor) {
        this.remove();
        return;
      }

      const trigger = this.querySelector('[data-tn-sticky-add]');
      if (trigger) {
        trigger.addEventListener('click', () => {
          // Reuse the real form so nothing is re-implemented here.
          if (typeof this.form.requestSubmit === 'function') {
            this.form.requestSubmit(this.anchor);
          } else {
            this.anchor.click();
          }
        });
      }

      if (!('IntersectionObserver' in window)) {
        this.remove();
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          const visible = entries[0].isIntersecting;
          this.toggle(!visible && entries[0].boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      this._observer.observe(this.anchor);

      // Keep the sticky label in step with the main button's disabled state.
      this._sync = () => {
        const trigger2 = this.querySelector('[data-tn-sticky-add]');
        if (!trigger2) return;
        trigger2.disabled = this.anchor.disabled;
        const label = this.anchor.querySelector('[data-tn-add-label]');
        if (label) trigger2.textContent = label.textContent.trim();
      };
      document.addEventListener('tn:variant:change', this._sync);
      this._sync();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      document.removeEventListener('tn:variant:change', this._sync);
    }

    toggle(show) {
      if (show) {
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
      } else {
        this.classList.remove('is-visible');
      }
    }
  }

  utils.define('tn-sticky-atc', TnStickyAtc);
})();
